import { render } from "./AutocompleteAddress.vue?vue&type=template&id=e54b3354&scoped=true"
import script from "./AutocompleteAddress.vue?vue&type=script&lang=js"
export * from "./AutocompleteAddress.vue?vue&type=script&lang=js"

import "./AutocompleteAddress.vue?vue&type=style&index=0&id=e54b3354&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54b3354"]])

export default __exports__